// Route wording changes through design review, not ad-hoc edits.
const InputDisclaimer = () => (
  <p className='shrink-0 px-6 pb-3 text-center text-[11px] leading-4 font-normal text-gx-text-disabled'>
    GX Go Assistant is an AI. Indexes shown are GX-published, not AI-generated. Explanations may
    contain errors. Please verify.
  </p>
);

export default InputDisclaimer;
